<template>
    <div class="af3-main-loop-sort-by" ref="sortByRef">

      <div class="af3-main-loop-sort-by-filter-bar-toggle-container">
        
        <button @click="handleFilterByClick">
          <span>FILTER BY</span>
          <svg xmlns="http://www.w3.org/2000/svg" width="6.182" height="10.95" viewBox="0 0 6.182 10.95">
            <path id="Path_46144" data-name="Path 46144" d="M9.89,5.475,5.122.707.354,5.475l-.707-.707L5.122-.707,10.6,4.768Z" transform="translate(5.475 0.354) rotate(90)" />
          </svg>
        </button>


      </div>

      <div class="af3-main-loop-sort-by-filter-bar-order-container">
        <button type="button" 
                @click="handleSortByClick" 
                class="af3-main-loop-sort-by-button" 
                aria-haspopup="listbox" 
                aria-label="Sort By" 
                :aria-expanded="is_open"
                id="sort-by-button">
          <span>SORT BY</span>
          <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="16.386" height="17.261" viewBox="0 0 16.386 17.261"><defs><clipPath id="a"><rect width="16.386" height="17.261" fill="none"/></clipPath></defs><g clip-path="url(#a)"><path d="M12.786,17.261h-.021a.508.508,0,0,1-.322-.136h0l-.008-.008-3.1-3.065a.5.5,0,0,1,.7-.711l2.249,2.225V3.411a.5.5,0,0,1,1,0V15.564l2.248-2.224a.5.5,0,0,1,.7.711l-3.1,3.064-.018.016a.5.5,0,0,1-.14.09.514.514,0,0,1-.176.04Z"/><path d="M3.6,14.349a.5.5,0,0,1-.5-.5V1.7L.851,3.921a.5.5,0,1,1-.7-.711L3.248.144A.475.475,0,0,1,3.578,0h.046a.5.5,0,0,1,.164.036h0a.493.493,0,0,1,.163.108l3.1,3.067a.5.5,0,1,1-.7.711L4.1,1.7V13.849a.5.5,0,0,1-.5.5"/></g></svg>        </button>
        <div class="af3-main-loop-sort-by-dropdown" 
             v-if="is_open" 
             role="listbox" 
             :aria-hidden="!is_open" 
             aria-labelledby="sort-by-button">
          <ul>
            <li v-for="option in options" :key="option.value">
              <button @click="handleSortBySelect(option.value)" 
                      type="button" 
                      role="option"
                      :aria-selected="selected_option === option.value"
                      class="af3-main-loop-sort-by-dropdown-button" 
                      :class="{ 'active': selected_option === option.value }">
                {{ option.label }}
              </button>
            </li>
          </ul>
        </div>
      </div>


        
    </div>
</template>
  
<script>

import { defineComponent, ref, watch, onMounted, reactive, onBeforeUnmount, nextTick } from 'vue';


export default defineComponent({
    components: {  },
   
    props: { },

    // Add emits declaration
    emits: ['sortBySelected'],

    setup(props, { emit }) {

      const is_open = ref(false);
      const selected_option = ref('least_bedrooms');
      const sortByRef = ref(null);
      
      const options = [
      { 
          label: 'Least Bedrooms',
          value: 'least_bedrooms'
        },
        {
          label: 'Most Bedrooms',
          value: 'most_bedrooms'
        },
      
        {
          label: 'Lowest Price',
          value: 'lowest_price'
        },
        {
          label: 'Highest Price',
          value: 'highest_price'
        },
        {
          label: 'Largest Unit',
          value: 'largest_unit'
        },
        {
          label: 'Smallest Unit',
          value: 'smallest_unit'
        }
      ];

      onMounted(() => {
        //get the url params
        const url = new URL(window.location.href);
        if (url.searchParams.get('sort_by')) {
          selected_option.value = url.searchParams.get('sort_by');
          emit('sortBySelected', selected_option.value);
        }
      });
     
      // Close dropdown when clicking outside
      const handleClickOutside = (event) => {
        if (sortByRef.value && !sortByRef.value.contains(event.target) && is_open.value) {
          is_open.value = false;
        }
      };

      // Close dropdown when escape key is pressed
      const handleKeyDown = (event) => {
        if (event.key === 'Escape' && is_open.value) {
          is_open.value = false;
        }
      };

      const handleFilterByClick = () => {
        nextTick(() => {
          emit('filterByMobileOpen');
        });
      }

      onMounted(() => {
        document.addEventListener('click', handleClickOutside);
        document.addEventListener('keydown', handleKeyDown);
      });

      onBeforeUnmount(() => {
        document.removeEventListener('click', handleClickOutside);
        document.removeEventListener('keydown', handleKeyDown);
      });

      const handleSortByClick = () => {
        is_open.value = !is_open.value;
      }

      const handleSortBySelect = (value) => {
        selected_option.value = value;
        is_open.value = false;
        emit('sortBySelected', value);
      }

            

    return { 
      handleSortByClick,
      handleSortBySelect,
      handleFilterByClick,
      is_open,
      options,
      selected_option,
      sortByRef
     };
  },


  
  
});
</script>